import {
  PublicClientApplication,
  type AccountInfo,
  type RedirectRequest,
} from "@azure/msal-browser";
import { reactive } from "vue";

export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_CLIENT_ID || "",
    authority: process.env.VUE_APP_AUTHORITY || "",
    redirectUri: window.location.origin, // Replace with your actual redirect URI
    postLogoutUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false,
  },
};
export const graphScopes: RedirectRequest = {
  scopes: ["user.read", "openid", "profile"],
};
export const apiScope = process.env.VUE_APP_BACKEND_SCOPE ?? "";

export const state = reactive({
  isAuthenticated: false,
  user: null as AccountInfo | null,
});

export const msalInstance = new PublicClientApplication(msalConfig);
